import {
  ARTICLES_PAGINATE,
  ARTICLE_STATUS,
  CREATE_ARTICLE,
  CREATE_LESSON,
  CREATE_SUBJECT,
  CREATE_UNIT,
  GET_ARTICLES,
  GET_ARTICLE,
  GET_LESSON,
  GET_LESSONS,
  GET_SUBJECTS,
  GET_UNITS,
  DELETE_ARTICLE,
  DELETE_SUBJECT,
  DELETE_LESSON,
  SUBJECTS_PAGINATE,
  SUBJECT_STATUS,
  UNITS_PAGINATE,
  UNIT_STATUS,
  DELETE_UNIT,
  UPDATE_ARTICLE,
  UPDATE_LESSON,
  UPDATE_SUBJECT,
  UPDATE_UNIT,
  LESSONS_PAGINATE,
  LESSON_STATUS,
  NOTIFICATIONS_INCLUDE
} from '@store/types'
import shortly from 'vuex-shortly'
import axios from 'axios'

const state = {
  lessonsPaginate: {},
  unitsPaginate: {},
  subjectsPaginate: {},
  articlesPaginate: {}
}

const getters = {
  [LESSONS_PAGINATE]: 'lessonsPaginate',
  [UNITS_PAGINATE]: 'unitsPaginate',
  [SUBJECTS_PAGINATE]: 'subjectsPaginate',
  [ARTICLES_PAGINATE]: 'articlesPaginate'
}

const mutations = {
  [LESSONS_PAGINATE]: 'lessonsPaginate',
  [UNITS_PAGINATE]: 'unitsPaginate',
  [SUBJECTS_PAGINATE]: 'subjectsPaginate',
  [ARTICLES_PAGINATE]: 'articlesPaginate'
}

const toFormData = payload => {
  const formData = new FormData()
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      formData.append(key, value)
    }
  })
  return formData
}

const toQueryString = params => {
  const query = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value)
    }
  })

  return query.toString()
}

const actions = {
  [GET_LESSONS]: async ({ commit }, params = {}) => {
    const query = toQueryString(params)
    const { data } = await axios.get(query ? `academy/lessons?${query}` : 'academy/lessons')
    commit(LESSONS_PAGINATE, data.meta || {})
    return data.data || []
  },
  [GET_LESSON]: async (_, id) => {
    const { data } = await axios.get(`academy/lessons/${id}`)
    return data.data
  },
  [CREATE_LESSON]: async ({ dispatch }, payload) => {
    const formData = toFormData(payload)
    const { data } = await axios.post('academy/lessons', formData)
    await dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Aula criada com sucesso!' })
    return data.data
  },
  [UPDATE_LESSON]: async ({ dispatch }, { id, ...payload }) => {
    const formData = toFormData(payload)
    const { data } = await axios.patch(`academy/lessons/${id}`, formData)
    await dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Aula atualizada com sucesso!' })
    return data.data
  },
  [LESSON_STATUS]: async ({ dispatch }, id) => {
    const { data } = await axios.patch(`academy/lessons/${id}/status`)
    await dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Status da aula atualizado com sucesso!' })
    return data.data
  },

  [DELETE_LESSON]: async ({ dispatch }, id) => {
    const { data } = await axios.delete(`academy/lessons/${id}`)
    await dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Aula excluída com sucesso!' })
    return data.data
  },

  [GET_UNITS]: async ({ commit }, params = {}) => {
    const query = toQueryString(params)
    const { data } = await axios.get(query ? `academy/units?${query}` : 'academy/units')
    commit(UNITS_PAGINATE, data.meta || {})
    return data.data || []
  },
  [CREATE_UNIT]: async ({ dispatch }, payload) => {
    const { data } = await axios.post('academy/units', payload)
    await dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Módulo criado com sucesso!' })
    return data.data
  },
  [UPDATE_UNIT]: async ({ dispatch }, payload) => {
    const { data } = await axios.patch(`academy/units/${payload.id}`, payload)
    await dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Módulo atualizado com sucesso!' })
    return data.data
  },
  [UNIT_STATUS]: async ({ dispatch }, id) => {
    const { data } = await axios.patch(`academy/units/${id}/status`)
    await dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Status do módulo atualizado com sucesso!' })
    return data.data
  },
  [DELETE_UNIT]: async ({ dispatch }, id) => {
    const { data } = await axios.delete(`academy/units/${id}`)
    await dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Módulo excluído com sucesso!' })
    return data.data
  },

  [GET_SUBJECTS]: async ({ commit }, params = {}) => {
    const query = toQueryString(params)
    const { data } = await axios.get(query ? `academy/subjects?${query}` : 'academy/subjects')
    commit(SUBJECTS_PAGINATE, data.meta || {})
    return data.data || []
  },
  [CREATE_SUBJECT]: async ({ dispatch }, payload) => {
    const { data } = await axios.post('academy/subjects', payload)
    await dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Assunto criado com sucesso!' })
    return data.data
  },
  [UPDATE_SUBJECT]: async ({ dispatch }, { id, ...payload }) => {
    const { data } = await axios.patch(`academy/subjects/${id}`, payload)
    await dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Assunto atualizado com sucesso!' })
    return data.data
  },
  [SUBJECT_STATUS]: async ({ dispatch }, id) => {
    const { data } = await axios.patch(`academy/subjects/${id}/status`)
    await dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Status do assunto atualizado com sucesso!' })
    return data.data
  },
  [DELETE_SUBJECT]: async ({ dispatch }, id) => {
    const { data } = await axios.delete(`academy/subjects/${id}`)
    await dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Assunto excluído com sucesso!' })
    return data.data
  },

  [GET_ARTICLES]: async ({ commit }, params = {}) => {
    const query = toQueryString(params)
    const { data } = await axios.get(query ? `academy/articles?${query}` : 'academy/articles')
    commit(ARTICLES_PAGINATE, data.meta || {})
    return data.data || []
  },
  [CREATE_ARTICLE]: async ({ dispatch }, payload) => {
    const formData = toFormData(payload)
    const { data } = await axios.post('academy/articles', formData)
    await dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Artigo criado com sucesso!' })
    return data.data
  },
  [GET_ARTICLE]: async (_, id) => {
    const { data } = await axios.get(`academy/articles/${id}`)
    return data.data
  },
  [UPDATE_ARTICLE]: async ({ dispatch }, { id, ...payload }) => {
    const formData = toFormData(payload)
    const { data } = await axios.patch(`academy/articles/${id}`, formData)
    await dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Artigo atualizado com sucesso!' })
    return data.data
  },
  [ARTICLE_STATUS]: async ({ dispatch }, id) => {
    const { data } = await axios.patch(`academy/articles/${id}/status`)
    await dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Status do artigo atualizado com sucesso!' })
    return data.data
  },
  [DELETE_ARTICLE]: async ({ dispatch }, id) => {
    const { data } = await axios.delete(`academy/articles/${id}`)
    await dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Artigo excluído com sucesso!' })
    return data.data
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/academy.js